module.exports = __webpack_public_path__ + "img/Болезни голеностопных суставов и стоп.6c9a9c88.jpg";